<!--
 * @Author: lijh(¯﹃¯*)
 * @Date: 2024-02-06 10:02:29
 * @LastEditors: lijh(¯﹃¯*)
 * @LastEditTime: 2024-02-22 16:15:49
 * @Description: description
-->
<template>
  <div style="width: 100%; overflow: hidden">
    <vue-office-docx
      v-if="isdocx"
      :src="preViewObj.url"
      @rendered="rendered"
      style="width: 100%; height: 100%"
    />
    <vue-office-excel
      v-if="isexcel"
      :src="preViewObj.url"
      @rendered="rendered"
      style="width: 100%; height: 100%"
    />
    <!-- <vue-office-pdf
      v-if="ispdf"
      :src="url"
      @rendered="rendered"
      style="width: 100%; height: 100%"
    /> -->

    <iframe
      v-if="ispdf"
      :src="preViewObj.url"
      frameborder="0"
      width="100%"
      height="100%"
    ></iframe>
  </div>
</template>

<script>
//引入VueOfficeDocx组件
import VueOfficeDocx from "@vue-office/docx";
//引入相关样式
import "@vue-office/docx/lib/index.css";
// 引入VueOfficeExcel组件;
import VueOfficeExcel from "@vue-office/excel";
//引入相关样式
import "@vue-office/excel/lib/index.css";
//引入VueOfficePdf组件
import VueOfficePdf from "@vue-office/pdf";

export default {
  components: {
    VueOfficeDocx,
    VueOfficeExcel,
    VueOfficePdf
  },
  props: {
    // 文件uuid
    preViewObj: {
      type: Object | File,
      default: () => {}
    }
  },
  data() {
    return {
      isdocx: false,
      isexcel: false,
      ispdf: false
    };
  },
  mounted() {
    this.previewFile();
  },
  // watch: {
  //   preViewObj: {
  //     immediate: true,
  //     handler(newVal) {
  //       this.previewFile();
  //     }
  //   }
  // },
  methods: {
    rendered() {
      console.log("渲染完成");
    },
    previewFile() {
      const type = this.getFileExtension(
        this.preViewObj.attachmentOriginalName
      );
      // 根据文件格式显示预览内容
      if (type === "xlsx") {
        this.isexcel = true;
      }
      if (type === "docx") {
        this.isdocx = true;
      }
      if (
        type === "pdf" ||
        type === "jpg" ||
        type === "png" ||
        type === "gif" ||
        type === "jpeg" ||
        type === "psd" ||
        type === "pptx" ||
        type === "txt"
      ) {
        this.ispdf = true;
      }
    },
    getFileExtension(filename) {
      // 使用split()将文件名按点号分隔为多个部分
      const parts = filename.split(".");
      if (parts.length > 1) {
        return parts[parts.length - 1]; // 返回最后一个部分作为后缀名
      } else {
        return ""; // 如果没有找到点号或者只有一个部分，则表示无后缀名
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/components/common/Preview.vue